import {
  GET_MEDIUM,
  EDIT_MEDIUM,
  EDIT_MEDIUM_AUTH,
} from "../../constants/type";

import Api from "../../utils/api";
import { EndPoints } from "../../constants/endpoints";
import { setData } from "./auth";

export const getData = () => {
  return (dispatch) => {
    return {
      type: GET_MEDIUM,
      payload: () => {
        return Api.get(EndPoints.medium()).then((response) => {
          if (response.status < 300) {
            dispatch(setData(response.data));
          }
          return response;
        });
      },
    };
  };
};

export const edit = (data) => {
  return (dispatch) => {
    return {
      type: EDIT_MEDIUM,
      payload: () => {
        return Api.put(EndPoints.medium(), data);
      },
    };
  };
};

export const editAuth = (data) => {
  return (dispatch) => {
    return {
      type: EDIT_MEDIUM_AUTH,
      payload: () => {
        return Api.put(EndPoints.medium("auth"), data);
      },
    };
  };
};
